import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'
import { ListItemText } from 'material-ui/List'
import Select from 'material-ui/Select'
import Checkbox from 'material-ui/Checkbox'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import Switch from 'material-ui/Switch'
import { FormGroup, FormControlLabel, FormLabel } from 'material-ui/Form'
import { LineChart, ReferenceLine, Line, Area, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Text, Label } from 'recharts'
import CustomLegend from '../legend'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

class PairSelector extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {

    const { classes, handlePairsSelection, selectedPairs, allPairs, combined, translate } = this.props

    return (
      <div ref="line-chart-container">
        <Grid container spacing={24}>
          <Grid className={classes.pairSelector} item xs={12} sm={12} lg={12} md={12} xl={12} alignContent={'flex-end'}>
            <Select
              multiple
              value={['']}
              renderValue={selected => [allPairs ? translate('All Pairs') : translate('Pairs')].join(', ')}
              onChange={handlePairsSelection}
            >
              <MenuItem value={'all'}>
                <Checkbox checked={allPairs} />
                <ListItemText primary={translate('All Pairs')} />
              </MenuItem> 

              {selectedPairs && selectedPairs.map((pair, key) => {
                return (
                  pair && (<MenuItem value={pair.key} key={key}>
                    <Checkbox checked={pair.checked} />
                    {(pair.value && pair.value.toLowerCase() === "limit") ? (
                      <ListItemText primary={translate(pair.value.toLowerCase())} />
                    ) : (
                        <ListItemText primary={pair.value} />
                      )}
                  </MenuItem>)
                )
              })}
            </Select>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(PairSelector)



// WEBPACK FOOTER //
// ./src/components/common/results/components/pairSelector/index.js